"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  aliceBlue: '#eef3f7',
  blue: '#134cd8',
  gray: '#979899',
  lightGray: '#f2f4f5',
  'hover-action-secondary': '#DBE9FD',
  'c-on-base': '#3f3f40',
  'muted-1': '#727273',
  'muted-2': '#979899',
  'muted-3': '#cacbcc',
  'muted-4': '#e3e4e6',
  red: '#ff4c4c'
};